<div class="relative h-screen bg-surface flex items-center justify-center p-6 overflow-hidden">
  <!-- Professional Medical Background Elements -->
  <div class="absolute inset-0 opacity-[0.03] pointer-events-none"
    style="background-image: radial-gradient(circle at 2px 2px, #4A90E2 1px, transparent 0); background-size: 40px 40px;">
  </div>

  <div
    class="absolute top-[10%] right-[10%] w-[500px] h-[500px] bg-primary/10 rounded-full blur-[120px] pointer-events-none animate-pulse">
  </div>
  <div
    class="absolute bottom-[10%] left-[10%] w-[400px] h-[400px] bg-accent/10 rounded-full blur-[100px] pointer-events-none">
  </div>

  <!-- Branding Header -->
  <div class="absolute top-12 left-12 hidden md:flex items-center gap-4">
    <img src="assets/images/logos/logo_horizontal.png" alt="Dentium" class="h-10 w-auto">
  </div>

  <!-- Theme Toggle -->
  <div class="absolute top-12 right-12">
    <app-theme-toggle></app-theme-toggle>
  </div>

  <!-- Content Container with Glassmorphism -->
  <div class="w-full max-w-2xl relative z-10 animate-fade-in">
    <router-outlet></router-outlet>
  </div>
</div>